import { Route } from 'react-router';
import { getDepositorWiresPath } from '../path/path';
import { DepositorWiresPage } from '../DepositorWiresPage';
import { getDepositorWireDetailsPath } from '../_DepositorWireDetailsPage/path/path';
import { DepositorWireDetailsPage } from '../_DepositorWireDetailsPage/DepositorWireDetailsPage';

export const DepositorRoutes = [
  <Route key={getDepositorWiresPath()} path={getDepositorWiresPath()} element={<DepositorWiresPage />} />,
  <Route
    key={getDepositorWireDetailsPath()}
    path={getDepositorWireDetailsPath()}
    element={<DepositorWireDetailsPage />}
  />,
];
